import { RRule } from 'rrule'
import moment from 'moment'

const parseDate = (date, time) => {
  return moment(date).hours(Number(time[0])).minutes(Number(time[1]))
}

export const formValuesToRruleString = (data) => {
  const time = data.recurrenceTime.split(':')

  const startDate = parseDate(data.startDate, time)
  let endDate = null

  if (data.endDate !== null) {
    endDate = parseDate(data.endDate, time)
  }

  const options = {
    freq: RRule[data.recurrenceType],
    dtstart: startDate._d,
    until: endDate?._d,
    interval: data.recurrenceValue,
  }

  if (data.recurrenceType === 'WEEKLY') {
    options.byweekday = data.selectedWeeklyDays.map((item) => RRule[item])
  } else if (data.recurrenceType === 'MONTHLY') {
    options.bymonthday = [data.selectedMonthlyDate]
  }

  return new RRule(options).toString()
}
